import { api } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  FetchLinkTrackingDomainsParams,
  FetchLinkTrackingDomainsResponse,
} from './types';

const _fetchLinkTrackingDomains = async ({
  accountId,
}: FetchLinkTrackingDomainsParams): Promise<
  AxiosResponse<FetchLinkTrackingDomainsResponse>
> => {
  return api.get(`v2/p2p/linktrackingdomains?account_id=${accountId}`);
};
const useFetchLinkTrackingDomains = (
  accountId?: FetchLinkTrackingDomainsParams['accountId'],
  enabled?: boolean
) => {
  return useQuery({
    queryKey: ['fetch-link-tracking-domains', { accountId }],
    queryFn: () => _fetchLinkTrackingDomains({ accountId: accountId! }),
    enabled: !!accountId && (!!enabled || typeof enabled === 'undefined'),
    retry: 1,
    staleTime: 5 * 60 * 1000,
  });
};

export { useFetchLinkTrackingDomains };
